import { NetworkClient, useClassFactory, useNetworkService } from "@pasta/box-v2";
import { type UserPreferencesDto, type WriteUserPreferencesDto } from "../dto/user-preferences.dto";
import { subject } from "@casl/ability";
import { type SignatureObjectDto, type WriteSignatureObjectDto } from "../dto/signature.dto";

export class UserPreferencesApi {
  protected readonly baseEndpoint = `user-preferences/`;

  protected get network(): NetworkClient {
    return useNetworkService();
  }

  map(entity: UserPreferencesDto): UserPreferencesDto {
    return subject("UserPreferences", entity);
  }

  async getMine() {
    const response = await this.network.get(`${this.baseEndpoint}my`);
    return this.map(response.data);
  }

  async updateMine(body: WriteUserPreferencesDto) {
    const response = await this.network.patch(`${this.baseEndpoint}my`, body);
    return this.map(response.data);
  }

  async updateSignObjects(signatures: WriteSignatureObjectDto[]): Promise<SignatureObjectDto[]> {
    const response = await this.network.put(`${this.baseEndpoint}my/signatures`, { signatures });
    return response.data.map(this.map.bind(this));
  }

  async getSignatureLink(id: number): Promise<string> {
    const response = await this.network.get(`${this.baseEndpoint}signature/${id}`);
    return response.data;
  }

  async getSignaturesDimension(user: string): Promise<any> {
    const response = await this.network.get(`${this.baseEndpoint}signatures-dimension/${user}`);
    return response.data;
  }
}

export const [userPreferencesApiToken, useUserPreferencesApi] = useClassFactory(UserPreferencesApi);
